// extracted by mini-css-extract-plugin
export default {"wrapper":"_f832bcfb","breadcrumb":"_c5a69913","breadcrumbLink":"_2c561a33"};